import axios from 'axios'
import {createSlice, createAsyncThunk, PayloadAction} from '@reduxjs/toolkit'
const api = '/api/'

export const studentBookList = createAsyncThunk(
  'school-student-book-list',
  async (params: {}, thunkAPI) => {
    try {
      const response = await axios.get(`${api}school-student-book/list`, params)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const ReturnBooks = createAsyncThunk('return', async (dat: any, thunkAPI) => {
  try {
    const {data} = await axios.post(`${api}school-student-book/return-sale`, dat)
    return data
  } catch (error: any) {
    return thunkAPI.rejectWithValue(error.response?.data?.errors)
  }
})

export const storeStudentBook = createAsyncThunk(
  'school-student-book-store',
  async (data: {}, thunkAPI) => {
    try {
      const response = await axios.post(`${api}school-student-book/store`, data)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data)
      }
    }
  }
)

export const getStudentBookById = createAsyncThunk(
  'school-student-book-get',
  async (student_book_id: any, thunkAPI) => {
    try {
      const response = await axios.get(`${api}school-student-book/edit/` + student_book_id)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data)
      }
    }
  }
)

export const viewStudentBook = createAsyncThunk(
  'school-student-book-view',
  async (student_book_id: any, thunkAPI) => {
    try {
      const response = await axios.get(`${api}school-student-book/view/` + student_book_id)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data)
      }
    }
  }
)

export const printStudentBook = createAsyncThunk(
  'student-book-print',
  async (id: string, thunkAPI) => {
    try {
      const response = await axios.get(`${api}school-student-book/print/${id}`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const StdBookPayments = createAsyncThunk('book-payments', async (id: any, thunkAPI) => {
  try {
    const response = await axios.get(`${api}school-student-book/payments/` + id)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data)
    }
  }
})

// graphs reports
export const SaleBookSummary = createAsyncThunk('sale-bk-sum', async (id: string, thunkAPI) => {
  try {
    const response = await axios.get(`${api}school-student-book/book-sale-summary/${id}`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const YearlyBookFeeDetails = createAsyncThunk(
  'yearly-bk-rep',
  async (data: {}, thunkAPI) => {
    try {
      const response = await axios.post(`${api}school-student-book/yearly-bs-rep`, data)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const YearlyBookFeePrint = createAsyncThunk(
  'yearly-fee-rep-prt',
  async (data: {}, thunkAPI) => {
    try {
      const response = await axios.post(`${api}school-student-book/yearly-bs-rep-print`, data)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const YearlybKFeeExcel = createAsyncThunk(
  'yearly-bK-excel',
  async (data: FormData, thunkAPI) => {
    try {
      const response = await axios.post(`${api}school-student-book/yearly-bs-rep-excel`, data, {
        responseType: 'blob',
      })

      return response.data
    } catch (error: any) {
      if (error.response?.data) {
        return thunkAPI.rejectWithValue(error.response.data)
      }
      return thunkAPI.rejectWithValue('Download failed')
    }
  }
)

type StudentBookState = {
  errors: any
}

const initialState: StudentBookState = {
  errors: '',
}

export const studentBookSlice = createSlice({
  name: 'student-book',
  initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(storeStudentBook.rejected, (state, action: PayloadAction<any>) => {
      state.errors = action.payload
    })
  },
})

export const {reset} = studentBookSlice.actions
export default studentBookSlice.reducer
